import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ConfigService } from '../services/config.service';
import * as CommonActions from './common.actions';
import { UserModel } from './common.models';
import { JwtUtils } from '@dcs-workspace/shared';
import { of } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable()
export class CommonEffects {
  constructor(
    private actions$: Actions,
    private configurationService: ConfigService,
    private userService: UserService
  ) {}

  setConfiguration$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommonActions.loadConfiguration),
      switchMap(() =>
        this.configurationService.loadConfig().pipe(
          map((configurationModel) =>
            CommonActions.loadConfigurationSuccess({
              config: configurationModel,
            })
          ),
          catchError((error) =>
            of(CommonActions.loadConfigurationError({ error }))
          )
        )
      )
    )
  );
  setUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommonActions.loadUser),
      switchMap((action) => {
        const parsedUser = JwtUtils.parseJwt(action.token);
        const user = {
          unique_name: parsedUser.unique_name ??
            parsedUser.upn ??
            parsedUser.username ??
            parsedUser.given_name + ' ' + parsedUser.family_name,
          personId: parsedUser.personId,
          isAdmin: parsedUser.isAdmin === 'true',
        } as UserModel;
        return of(CommonActions.loadUserSuccess({ user }));
      })
    )
  );
  loadUserEntitlements$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CommonActions.loadUserEntitlements),
      switchMap(() =>
        this.userService.loadUserEntitlements().pipe(
          map((entitlements) =>
            CommonActions.loadUserEntitlementsSuccess({ entitlements })
          )
          // catchError(error => of(FeatureActions.actionFailure({ error }))))
        )
      )
    );
  });
}
